import AdapterDateFns from "@mui/lab/AdapterDateFns";
import DesktopDatePicker from "@mui/lab/DesktopDatePicker";
import LocalizationProvider from "@mui/lab/LocalizationProvider";
import TimePicker from "@mui/lab/TimePicker";
import TextField from "@mui/material/TextField";
import axios from "axios";
import { convertToHTML } from "draft-convert";
import { EditorState } from "draft-js";
import moment from "moment";
import React, { useEffect, useState } from "react";
import { Editor } from "react-draft-wysiwyg";
import "react-draft-wysiwyg/dist/react-draft-wysiwyg.css";
import { CKEditor } from "@ckeditor/ckeditor5-react";
import ClassicEditor from "@ckeditor/ckeditor5-build-classic";

import { Link } from "react-router-dom";
import "./AddProductS.css";
import UploadAuctionComponent from "./UploadAuctionComponent";
import { useHistory } from "react-router-dom";

const AddProductSouvenir = () => {
  const [convertedContent, setConvertedContent] = useState(null);
  const [file, setFile] = useState(null);
  const [product, setProduct] = useState(null);
  const [starList, setStarList] = useState([]);
  const [category_id, setCategoryId] = useState("");
  const [subcategory_id, setSubcategoryId] = useState("");
  const [categories, setCategory] = useState([]);
  const [subcategories, setSubcategory] = useState([]);
  const [errorList, setErrorList] = useState([]);

  const history = useHistory();

  const [editorState, setEditorState] = useState(() =>
    EditorState.createEmpty()
  );
  const [inputFieldList, setInputFieldList] = useState({
    title: "",
    keyword: "",
    details: "",
    star_id: "",
    category_id: "",
    subcategory_id: "",
    base_price: "",
    bid_from: "",
    bid_to: "",
    result_date: "",
    product_delivery_date: "",
    banner: "",
    product_image: "",
  });
  const selectState = (e) => {
    let value = e.target.value;
    var data = value;

    axios.get(`/api/fetch-subcategory/${data}`).then((res) => {
      if (res.status === 200) {
        setSubcategory(res.data.category);
      }
      //   setLoading(false);
    });

    setCategoryId(data);
  };

  const handleInput = (e) => {
    const { name, value } = e.target;
    setInputFieldList((prev) => {
      return { ...prev, [name]: value };
    });
  };

  // Fetch Stars Added By Admin
  useEffect(() => {
    axios.get(`/api/admin/star_list`).then((res) => {
      if (res.status === 200) {
        setStarList(res.data.star);
      }
    });
    axios.get(`/api/admin/view-category`).then((res) => {
      if (res.status === 200) {
        setCategory(res.data.category);
      }
    });
  }, []);

  const handleEditorChange = (state) => {
    setEditorState(state);
    convertContentToHTML();
  };

  const convertContentToHTML = () => {
    let currentContentAsHTML = convertToHTML(editorState.getCurrentContent());
    setConvertedContent(currentContentAsHTML);
  };

  const [startDate, setStartDate] = useState(new Date());
  const [endDate, setEndDate] = useState(new Date());
  const [resultDate, setResultDate] = useState(new Date());
  const [productDeliveryDate, setDeliveryDate] = useState(new Date());

  const handleChange = (newValue) => {
    setStartDate(newValue);
  };
  const handleEndChange = (secondValue) => {
    setEndDate(secondValue);
  };
  const handleResultChange = (thirdValue) => {
    setResultDate(thirdValue);
  };
  const handleProductDeliveryChange = (forthValue) => {
    setDeliveryDate(forthValue);
  };

  const [imageUpload, setImageUpload] = useState({
    upload: {
      pictures: [],
      maxFileSize: 5242880,
      imgExtension: [".jpg", ".png", ".jpeg"],
      defaultImages: [],
    },
  });

  const handleAuctionChange = (files) => {
    const { pictures } = imageUpload.upload;
    console.warn({ pictures, files });

    setImageUpload(
      {
        ...imageUpload,
        upload: {
          ...imageUpload.upload,
          pictures: [...pictures, ...files],
        },
      },
      () => {
        console.warn("It was added!");
      }
    );
  };

  const handleOnChange = (e) => {
    setFile(e.target.files[0]);
  };

  const handleProductChange = (e) => {
    setProduct(e.target.files[0]);
  };

  const dataSubmit = (e) => {
    e.preventDefault();
    const fData = new FormData();

    fData.append("title", inputFieldList.title);
    fData.append("keyword", inputFieldList.keyword);
    fData.append("star_id", inputFieldList.star_id);
    fData.append("category_id", category_id);
    fData.append("subcategory_id", subcategory_id);
    fData.append("details", convertedContent);
    fData.append("base_price", inputFieldList.base_price);
    fData.append("bid_from", moment(startDate).format("yyyy-MM-DD HH:mm:ss"));
    fData.append("bid_to", moment(endDate).format("yyyy-MM-DD HH:mm:ss"));
    fData.append(
      "result_date",
      moment(resultDate).format("yyyy-MM-DD HH:mm:ss")
    );
    fData.append(
      "product_delivery_date",
      moment(productDeliveryDate).format("yyyy-MM-DD HH:mm:ss")
    );
    fData.append("banner", file);
    fData.append("status", 0);
    fData.append("product_image", product);

    axios.get("/sanctum/csrf-cookie").then((response) => {
      axios.post(`/api/admin/add/auction/product`, fData).then((res) => {
        if (res.data.status === 402) {
          setErrorList(res.data.errors);
        } else {
          history.push("/superstar-admin/auction/confirm-or-edit-auction");
        }

        /*    if (res.data.status === 200) {
                // document.getElementById('input_form').reset();   
                swal("Success", res.data.message, "success");
                history.push('/superstar-admin/live-chat/pending');
              }
              else {
                //setModalShow(true);
                setRegister({ ...registerInput, error_list: res.data.validation_errors });
              } */
      });
    });
  };

  return (
    <div className="AS m-3">
      {/* <SouvenirNav /> */}

      <div className="greetingsFormBorder">
        <div className="greetingsPadding addMeetUpPadding">
          <div className="d-flex">
            <div className="addIconGreetings">
              <i
                style={{ color: "#ffc107" }}
                className="far fa-plus-square mx-2"
              ></i>
            </div>
            <h3 className="text-warning text-bold">Add Product </h3>
          </div>
          <form>
            <div className="form-group row my-4">
              <label className="col-md-1 col-form-label col-form-label-sm input-text-lv-ch">
                Select Star
              </label>
              <div className="col-md-11">
                <select
                  onChange={handleInput}
                  name="star_id"
                  className="form-control reply-control"
                  value={inputFieldList.star_id}
                >
                  <option className="text-black" value="">
                    Choose One
                  </option>
                  {starList.map((star, index) => (
                    <option className="text-black" value={star.id}>
                      {star?.first_name} {star?.last_name}
                    </option>
                  ))}
                </select>
                <span className="text-danger">{errorList.star_id}</span>
              </div>
            </div>
            <div className="row my-4">
              <div className="col-md-2 text-white">
                <p>
                  <big>Select Category</big>
                </p>
              </div>
              <div className="col-md-3">
                <select
                  onChange={selectState}
                  name="category_id"
                  value={category_id}
                  className="form-control reply-control"
                >
                  <option className="text-black" value="">
                    Choose One
                  </option>
                  {categories.map((category, index) => (
                    <option className="text-black" value={category.id}>
                      {category.name}
                    </option>
                  ))}
                </select>
                <span className="text-danger">{errorList.category_id}</span>
              </div>
              <div className="col-md-2 text-white">
                <p>
                  <big>Select Subcategory</big>
                </p>
              </div>
              <div className="col-md-3">
                <select
                  onChange={(event) => {
                    setSubcategoryId(event.target.value);
                  }}
                  name="subcategory_id"
                  value={subcategory_id}
                  className="form-control reply-control"
                >
                  <option className="text-black" value="">
                    Choose One
                  </option>
                  {subcategories.map((subcategory, index) => (
                    <option className="text-black" value={subcategory.id}>
                      {subcategory.name}
                    </option>
                  ))}
                </select>
                <span className="text-danger">{errorList.subcategory_id}</span>
              </div>
            </div>

            <div className="row my-4">
              <div className="col-md-1">
                <p className="text-white">Title</p>
              </div>
              <div className="col-md-11">
                <input
                  className="form-control input-gray"
                  type="text"
                  onChange={handleInput}
                  name="title"
                  value={inputFieldList.title}
                />
                <span className="text-danger">{errorList.title}</span>
              </div>
            </div>

            <div className="row my-4">
              <div className="col-md-1">
                <p className="text-white">Keyword</p>
              </div>
              <div className="col-md-11">
                <input
                  className="form-control input-gray"
                  type="text"
                  onChange={handleInput}
                  name="keyword"
                  value={inputFieldList.keyword}
                />
              </div>
            </div>

            <div className="row my-4">
              <div className="col-md-1 text-white">
                <p>Description</p>
              </div>
              <div className="col-md-11">
                <CKEditor
                  editor={ClassicEditor}
                  data={convertedContent}
                  onReady={(editor) => {
                    // You can store the "editor" and use when it is needed.
                  }}
                  onChange={(event, editor) => {
                    const data = editor.getData();
                    setConvertedContent(data);
                  }}
                  onBlur={(event, editor) => {}}
                  onFocus={(event, editor) => {}}
                />
              </div>
              {/* <div className="col-md-11">

                                <Editor
                                    editorState={editorState}
                                    onEditorStateChange={handleEditorChange}
                                    wrapperClassName="wrapper-class"
                                    editorClassName="editor-class"
                                    toolbarClassName="toolbar-class"
                                />
                            </div> */}
              {/* <span className="text-danger">{errorList.description}</span> */}
            </div>

            <div className="row my-4">
              <div className="col-md-1">
                <p className="text-white">Base Price</p>
              </div>
              <div className="col-md-3">
                <input
                  className="form-control input-gray"
                  type="number"
                  name="base_price"
                  onChange={handleInput}
                  value={inputFieldList.base_price}
                />
                <span className="text-danger">{errorList.base_price}</span>
              </div>
            </div>

            <div className="row my-4">
              <div className="col-md-1 text-white">
                <p>
                  <small>Deadline</small>
                </p>
              </div>

              <div className="col-md-10">
                <LocalizationProvider dateAdapter={AdapterDateFns}>
                  {/* <Stack spacing={3}> */}
                  <div className="row dateDesktopPicker">
                    <div className="col-md-3">
                      <DesktopDatePicker
                        label="BID FROM"
                        inputFormat="MM/dd/yyyy"
                        value={startDate}
                        onChange={handleChange}
                        renderInput={(params) => <TextField {...params} />}
                      />
                      <span className="text-danger">{errorList.bid_from}</span>
                    </div>
                    <div className="col-md-3">
                      <DesktopDatePicker
                        label="BID TO"
                        inputFormat="MM/dd/yyyy"
                        value={endDate}
                        onChange={handleEndChange}
                        renderInput={(params) => <TextField {...params} />}
                      />
                      <span className="text-danger">{errorList.bid_to}</span>
                    </div>
                  </div>

                  {/* </Stack> */}
                </LocalizationProvider>
              </div>
            </div>

            <div className="row my-4">
              <div className="col-md-1 text-white">
                <p>
                  <small>Result Published</small>
                </p>
              </div>

              <div className="col-md-10">
                <LocalizationProvider dateAdapter={AdapterDateFns}>
                  {/* <Stack spacing={3}> */}
                  <div className="row dateDesktopPicker">
                    <div className="col-md-3">
                      <DesktopDatePicker
                        label="Result"
                        inputFormat="MM/dd/yyyy"
                        value={resultDate}
                        onChange={handleResultChange}
                        renderInput={(params) => <TextField {...params} />}
                      />
                      {/* <span className="text-danger">{errorList.bid_from}</span> */}
                    </div>
                  </div>

                  {/* </Stack> */}
                </LocalizationProvider>
              </div>
            </div>
            <div className="row my-4">
              <div className="col-md-1 text-white">
                <p>
                  <small>Product Delivery</small>
                </p>
              </div>

              <div className="col-md-10">
                <LocalizationProvider dateAdapter={AdapterDateFns}>
                  {/* <Stack spacing={3}> */}
                  <div className="row dateDesktopPicker">
                    <div className="col-md-3">
                      <DesktopDatePicker
                        label="Product Delivery"
                        inputFormat="MM/dd/yyyy"
                        value={productDeliveryDate}
                        onChange={handleProductDeliveryChange}
                        renderInput={(params) => <TextField {...params} />}
                      />
                      {/* <span className="text-danger">{errorList.bid_from}</span> */}
                    </div>
                  </div>

                  {/* </Stack> */}
                </LocalizationProvider>
              </div>
            </div>

            {/* <div className="row"> */}

            {/* <div className="col-md-4"> */}
            <div className="row my-4">
              <div className="col-md-1 text-white">
                <p>Upload Banner</p>
              </div>
              <div className="col-md-3">
                <input
                  onChange={handleOnChange}
                  type="file"
                  name="banner"
                  id="file"
                  className="inputfile"
                />

                <label for="file">
                  <i className="fas fa-cloud-upload-alt"></i> Upload
                </label>
                <span className="text-danger">{errorList.banner}</span>
              </div>
            </div>
            {file ? (
              <div className="row">
                <div className="col-md-1 text-light">
                  <small>Selected Banner</small>
                </div>
                <div className="col-md-11 fw-bold text-success">
                  {file?.name}
                </div>
              </div>
            ) : null}

            {/* 
                        <div className="row my-4">
                            <div className="col-md-1 text-white">
                                <p>Upload Images</p>
                            </div>
                            <div className="col-md-3">
                                <UploadAuctionComponent {...imageUpload.upload} handleAuctionChange={handleAuctionChange} />

                            </div>
                        </div> */}

            <div className="row my-4">
              <div className="col-md-1 text-white">
                <p>Product Image</p>
              </div>
              <div className="col-md-3">
                <input
                  onChange={handleProductChange}
                  type="file"
                  name="product_image"
                  id="product"
                  className="inputfile"
                />

                <label for="product">
                  <i className="fas fa-cloud-upload-alt"></i> Upload
                </label>
                <span className="text-danger">{errorList.product_image}</span>
              </div>
            </div>
            {product ? (
              <div className="row">
                <div className="col-md-1 text-light">
                  <small>Selected Product</small>
                </div>
                <div className="col-md-11 fw-bold text-success">
                  {product?.name}
                </div>
              </div>
            ) : null}

            {/*   <div className="mt-3">
                            <Link to="/superstar-admin/souvenir/confirm-or-edit-auction">
                                <button className="btn btn-warning save-greetings-button py-2"><big><b>Confirm</b></big></button>
                            </Link>

                        </div> */}
          </form>
          <div className="mt-3">
            <button
              className="btn btn-warning save-greetings-button py-2"
              type="submit"
              onClick={dataSubmit}
            >
              <big>
                <b>Confirm</b>
              </big>
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default AddProductSouvenir;
